import { ref, computed } from "vue";
import en from "../locales/en.json";
import fr from "../locales/fr.json";

const locales = { en, fr };
const currentLocale = ref("en");

/**
 * Get nested value from object using dot notation
 * @param {Object} obj
 * @param {string} path - e.g. "home.tryItYourself"
 */
function getNestedValue(obj, path) {
  return path.split(".").reduce((acc, key) => acc?.[key], obj);
}

/**
 * Translate a key
 * @param {string} key - e.g. "home.tryItYourself"
 * @returns {string}
 */
function t(key) {
  const value = getNestedValue(locales[currentLocale.value], key);
  if (value) return value;
  // Fallback to English
  const fallback = getNestedValue(locales.en, key);
  return fallback || key;
}

/**
 * Set the current locale
 * @param {string} locale - "en" or "fr"
 */
function setLocale(locale) {
  if (locales[locale]) {
    currentLocale.value = locale;
  }
}

/**
 * Get the current locale
 * @returns {string}
 */
function getLocale() {
  return currentLocale.value;
}

export default {
  install(app) {
    const i18n = {
      t,
      setLocale,
      getLocale,
      locale: currentLocale,
    };

    app.provide("i18n", i18n);
    app.config.globalProperties.$t = t;
    app.config.globalProperties.$i18n = i18n;
  },
};

export { t, setLocale, getLocale, currentLocale };

